// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "root-26CPQ";
var _3 = "option-1X_9K";
var _4 = "selected-4IO2P";
var _5 = "separator-3aVbq";
var _6 = "icon-1tGnB";
var _7 = "label-M_mYH";
export { _1 as "__esModule", _2 as "root", _3 as "option", _4 as "selected", _5 as "separator", _6 as "icon", _7 as "label" }
export default { "__esModule": _1, "root": _2, "option": _3, "selected": _4, "separator": _5, "icon": _6, "label": _7 }
